import { createStackNavigator } from '@react-navigation/stack'
import { lazy } from 'react'
import { Header } from '../comps/Header'
import { AgentTransactionHistory } from '../screens/AgentTransactionHistory'
import { RechargeBillPayments } from '../screens/BbpsBillPayments'
import { BbpsHomeScreen } from '../screens/BbpsHomeScreens'
import { BbpsCustomerOnboard } from '../screens/BbpsHomeScreens/BbpsCustomerOnboard'
import { BbpsLoadInitial } from '../screens/BbpsLoadInitials'
import { LoadInitialsScreen } from '../screens/LoadInitialsScreen'
import { MobileRechargeScreen } from '../screens/MobileRecharge'
import { CustomerOnboardingFlow } from '../screens/MobileRecharge/CustomerOnboardingFlow'
import { MobileBillPayment } from '../screens/MobileRecharge/MobileBillPayment'
import { TransactionDetails } from '../screens/TransactionDetails'
import { TransactionErrorDetails } from '../screens/TransactionDetails/TransactionErrorScreen'
import { ViewDetails } from '../screens/TransactionDetails/ViewDetails'
import { Screens } from './Screens'
// import { SeeAllOrderHistory } from '../screens/BbpsHomeScreens/SeeAllOrderHistory'
// import { SeeAllFavourite } from '../screens/BbpsHomeScreens/SeeAllFavourite'

const VerifyOTPScreen = lazy(() => import('../screens/MobileRecharge/VerifyOTP'))
const RegisterUserScreen = lazy(() => import('../screens/MobileRecharge/RegisterUser'))
const BbpsBillerScreen = lazy(() =>
  import('../screens/BbpsBillPayments/BbpsBillerScreen').then((module) => ({
    default: module.BbpsBillerScreen,
  })),
)
const BbpsBillDetailsScreen = lazy(() =>
  import('../screens/BbpsBillPayments/BbpsBillDetailsScreen').then((module) => ({
    default: module.BbpsBillDetailsScreen,
  })),
)
const PaymentProcessingScreen = lazy(() =>
  import('../screens/BbpsBillPayments/PaymentProcessingScreen').then((module) => ({
    default: module.PaymentProcessingScreen,
  })),
)

const TransactionDetailsScreen = lazy(() =>
  import('../screens/BbpsHomeScreens/TransactionDetailsScreen').then((module) => ({
    default: module.TransactionDetailsScreen,
  })),
)

const SeeAllFavourite = lazy(() =>
  import('../screens/BbpsHomeScreens/SeeAllFavourite').then((module) => ({
    default: module.SeeAllFavourite,
  })),
)

const SeeAllOrderHistory = lazy(() =>
  import('../screens/BbpsHomeScreens/SeeAllOrderHistory').then((module) => ({
    default: module.SeeAllOrderHistory,
  })),
)

const LoginScreen = lazy(() => import('../screens/DomesticMoneyTransfer/Login'))
const EnterCustomerDetails = lazy(() => import('../screens/DomesticMoneyTransfer/EnterCustomerDetails'))
const BeneficiaryForm = lazy(() => import('../screens/DomesticMoneyTransfer/EnterBeneficiaryDetails'))
const NoBeneficiaryFound = lazy(() => import('../screens/DomesticMoneyTransfer/NoBeneficiaryFound'))
const TransactionSuccessScreen = lazy(() => import('../screens/DomesticMoneyTransfer/TransactionSuccessful'))
const BeneficiaryList = lazy(() => import('../screens/DomesticMoneyTransfer/BeneficiaryList'))
const TransferFundScreen = lazy(() => import('../screens/DomesticMoneyTransfer/TransferFundScreen'))
const OtpScreen = lazy(() => import('../screens/DomesticMoneyTransfer/Otp'))
const SearchIFSC = lazy(() => import('../screens/DomesticMoneyTransfer/SearchIFSC'))
const ScanFaceOrFingerprintScreen = lazy(() => import('../screens/DomesticMoneyTransfer/ScanFaceOrFingerprintScreen'))

// export type AuthenticatorItem = {
//   authInfo: {
//     displayName: string
//     dataType: 'N' | 'A' | 'AN'| 'L'
//     fieldErrorMessage: string
//     fieldValidationPattern: string
//     displayOrder: string
//     valueList?: any[]
//   }
//   // Add other fields from the API response if necessary
// }

export type AuthenticatorItem = {
  authInfo: {
    displayName: string
    dataType: 'N' | 'A' | 'AN' | 'L' | 'V'
    fieldErrorMessage: string
    fieldValidationPattern: string
    displayOrder: string
    fieldMinimumLength?: string
    valueList?: any[]
  }
  product?: {
    id: number
    status: string
  }
  category?: {
    name: string
  }
  config?: {
    enabled: string
    select: string
    onlineValidateFlag: string
  }
}

export type CategoryDetailsParams = {
  mobileNumber: string
  categoryId: number | string
  categoryName: string
  displayName: string
}

export type BillerItem = {
  product: {
    id: string | number
    displayName: string
    logoName: string
    type: string
    isBbps: string
    partialPaymentType: string
  }
  category?: {
    id: number | string
    name: string
  }
}
export type BbpsBillerParams = {
  billerDetails: BillerItem
  authenticators: AuthenticatorItem[]
  productId: number | string
  categoryDetails: CategoryDetailsParams
  preFilledAuthenticators?: string[]
}

export type CustomerInput = {
  paramName: string
  paramValue: string
}
export type BbpsBillDetailsParams = {
  billDetails: any // Use a more specific BillDetails interface later
  billerDetails: BillerItem
  categoryDetails: CategoryDetailsParams
  customerInputs: CustomerInput[]
}

export type ResolvedDataParams = {
  amount: number
  customerName: string
  billerName: string
}
export type PaymentProcessingParams = {
  redirectionUrl: string
  orderId: string | number
  pgPayload: any
  isRecovery: boolean
  billDetails?: any
  billerDetails?: BillerItem
  categoryDetails?: CategoryDetailsParams
  resolvedData?: ResolvedDataParams
}

// 1. FavoriteTransaction Type (from fetchFavoriteTransactionsBC)
export type FavoriteTransaction = {
  // Required fields for rendering the slidable card
  billerMasterId: number
  billerShortName: string // e.g., 'ICICI Bank FASTag'
  shortName: string // e.g., 'Prakash' (Customer Name)
  authenticators: string[] // e.g., ['MH034589'] (Account Number/ID)
  creationDate: number[] // e.g., [2025, 7, 17, ...] (Date array)
  // Include any other fields your API returns if you need them later
}

// 2. OrderHistoryItem Type (from getOrderHistoryActionBC)
// Note: This matches the structure of the *mapped* item (the 'order' object)
export type OrderHistoryItem = {
  id: string // Order ID
  status: string // e.g., 'SUCCESS', 'PENDING'
  product: {
    name: string // e.g., 'ICICI Bank FASTag' (Biller/Product Name)
    attribute: {
      authenticatorList: string[] // e.g., ['MH034589'] (Account Number/ID)
    }
  }
  payment: {
    paymentAt: string // ISO date string for last payment/link time
  }
  bill: {
    customerName: string // e.g., 'Prakash'
  }
  // Add other necessary fields from the 'order' object if used
}

export type OrderType = {
  id: string
  status: string
  product: {
    name: string
    attribute: {
      authenticatorList: string[]
    }
  }
  payment: {
    paymentAt: string
  }
  bill: {
    customerName: string
  }
}

export type ProductDetails = {
  id: number
  name: string
}

export type CircleDetails = {
  id: number
  name: string
}

export type TransactionDetailsParams = {
  title: string
  data: FavoriteTransaction[] | OrderType[] // <-- Change OrderHistoryItem['order'] to OrderType
  type: 'favorites' | 'history'
}

export type LRNMappingItem = {
  product: ProductDetails
  circleDetails: CircleDetails
}

export type MobileBillPaymentParams = CategoryDetailsParams & {
  lrnMapping: LRNMappingItem[] | any
}

export type AgentExistsResponse = {
  responseObj?: {
    // Use optional chaining for safety
    agent?: {
      agentStatus?: {
        reasonCode: string // '0', '1', '2', etc.
        reasonMessage: string
      }
      // ... other agent properties if any
    }
  }
  status?: string
}

export type GenericTransactionSuccessParams = {
  status: 'Success'
  orderId: string | number
  message: string
}

export type GenericTransactionErrorParams = {
  orderId: string
  errorMessage: string
  paymentData: any
}

export type BbpsStackParamList = {
  // ... Will Define all screens and their parameter types Later here ...
  [Screens.LOAD_INITIALS]: undefined
  [Screens.BBPS_HOME_SCREEN]: undefined
  [Screens.CUSTOMER_ONBORD]: undefined
  [Screens.MOBILE_RECHARGE]: undefined
  [Screens.ADD_CUSTOMER]: {
    categoryId: number | string
    categoryName: string
    displayName: string
  }
  [Screens.RECHARGE_BILL_PAYMENTS]: CategoryDetailsParams // Use the shared type
  [Screens.MOBILE_BILL_PAYMENTS]: MobileBillPaymentParams
  [Screens.TRANSACTION_DETAILS]: GenericTransactionSuccessParams
  [Screens.VIEW_DETAILS]: any
  [Screens.TRANSACTION_ERROR_DETAILS]: GenericTransactionErrorParams
  [Screens.AGENT_TRANSACTION_HISTORY]: undefined
  [Screens.BBPS_LOAD_INITIAL]: {
    agentExistsResponse: AgentExistsResponse
  }
  [Screens.VERIFY_OTP]: CategoryDetailsParams
  [Screens.REGISTER_USER]: { mobileNumber: string; authorizationCode: string }
  [Screens.BbpsBillerScreen]: BbpsBillerParams
  [Screens.BbpsBillDetailsScreen]: BbpsBillDetailsParams
  [Screens.PaymentProcessingScreen]: PaymentProcessingParams
  [Screens.TRANSACTION_DETAILS_SCREEN]: TransactionDetailsParams
  [Screens.SeeAllFavourite]: undefined
  [Screens.SeeAllOrderHistory]: undefined
  // ... Will define other screens ...
  // [key: string]: object | undefined
}

export const Bbps = () => {
  const Stack = createStackNavigator<BbpsStackParamList>()
  console.log('bbpsloading::')

  return (
    <Stack.Navigator
      id={undefined}
      screenOptions={{
        header: Header,
        cardStyle: { flex: 1 },
      }}>
      <Stack.Screen name={Screens.LOAD_INITIALS} component={LoadInitialsScreen} />
      <Stack.Screen
        name={Screens.BBPS_HOME_SCREEN}
        component={BbpsHomeScreen}
        options={{
          headerTitle: 'Bill Pay Services',
        }}
      />
      <Stack.Screen
        name={Screens.CUSTOMER_ONBORD}
        component={BbpsCustomerOnboard}
        options={{
          headerTitle: 'Bills',
        }}
      />
      <Stack.Screen
        name={Screens.MOBILE_RECHARGE}
        component={MobileRechargeScreen}
        options={{
          headerTitle: 'Prepaid Recharge',
        }}
      />
      <Stack.Screen
        name={Screens.ADD_CUSTOMER}
        component={CustomerOnboardingFlow}
        options={{
          headerTitle: 'Bills',
        }}
      />
      <Stack.Screen
        name={Screens.VERIFY_OTP}
        component={VerifyOTPScreen}
        options={{
          headerTitle: 'Verify OTP',
        }}
      />
      <Stack.Screen
        name={Screens.REGISTER_USER}
        component={RegisterUserScreen}
        options={{
          headerTitle: 'Register Customer',
        }}
      />
      <Stack.Screen
        name={Screens.RECHARGE_BILL_PAYMENTS}
        component={RechargeBillPayments}
        options={{
          headerTitle: 'Billers',
        }}
      />
      <Stack.Screen
        name={Screens.MOBILE_BILL_PAYMENTS}
        component={MobileBillPayment}
        options={{
          headerTitle: 'Prepaid mobile-recharge',
          headerShown: false,
          cardStyle: {
            borderRadius: 0,
            flex: 0,
          },
        }}
      />
      <Stack.Screen
        name={Screens.TRANSACTION_DETAILS}
        component={TransactionDetails}
        options={{
          headerTitle: 'Transaction Details',
        }}
      />
      <Stack.Screen
        name={Screens.VIEW_DETAILS}
        component={ViewDetails}
        options={{
          headerTitle: 'View-Details',
        }}
      />
      <Stack.Screen
        name={Screens.TRANSACTION_ERROR_DETAILS}
        component={TransactionErrorDetails}
        options={{
          headerTitle: 'Transaction Error',
        }}
      />
      <Stack.Screen
        name={Screens.AGENT_TRANSACTION_HISTORY}
        component={AgentTransactionHistory}
        options={{
          headerTitle: 'agent transaction details',
        }}
      />
      <Stack.Screen
        name={Screens.BBPS_LOAD_INITIAL}
        component={BbpsLoadInitial}
        options={{
          headerTitle: 'Load Initials',
        }}
      />
      <Stack.Screen
        name={Screens.BbpsBillerScreen}
        component={BbpsBillerScreen}
        options={{
          headerTitle: 'Enter Biller Details',
        }}
      />
      <Stack.Screen
        name={Screens.BbpsBillDetailsScreen}
        component={BbpsBillDetailsScreen}
        options={{
          headerTitle: 'Bill Details',
        }}
      />
      <Stack.Screen
        name={Screens.PaymentProcessingScreen}
        component={PaymentProcessingScreen}
        options={{
          headerTitle: 'Payment Processing',
          // headerShown: false,
          // cardStyle: {
          //   borderRadius: 0,
          //   flex: 0,
          // },
        }}
      />
      <Stack.Screen
        name={Screens.TRANSACTION_DETAILS_SCREEN}
        component={TransactionDetailsScreen}
        options={{
          headerTitle: 'Transactions List',
        }}
      />
      <Stack.Screen
        name={Screens.SeeAllFavourite}
        component={SeeAllFavourite}
        options={{
          headerTitle: 'Transactions List',
        }}
      />
      <Stack.Screen
        name={Screens.SeeAllOrderHistory}
        component={SeeAllOrderHistory}
        options={{
          headerTitle: 'Transactions List',
        }}
      />
    </Stack.Navigator>
  )
}
